<template>
  <wui-modal
    :title="$t('common.selectTerminalToCall')"
    :size="40"
    :closable="true"
    @close="close"
  >
    <div class="grid grid-cols-[6fr_13fr]">
      <div class="flex items-center justify-center border-r border-bor-divider bg-bg-base-bg3">
        <wui-icon
          class="h-14! w-14! text-fg-base-fg22"
          name="pcDevices"
        />
      </div>
      <div
        class="p-2"
        :class="{
          'flex items-center justify-center': terminals.length === 0
        }"
      >
        <ul
          v-if="terminals.length > 0"
          class="flex flex-col gap-1"
        >
          <li
            v-for="terminal in terminals"
            :key="terminal.id"
            class="group min-w-60 cursor-pointer rounded-8 px-4 py-2 text-1316 hover:bg-bg-base-bg3"
            @click="choice(terminal)"
          >
            <div class="flex items-center justify-between gap-2">
              <div class="flex flex-col gap-1">
                <div class="text-fg-base-fg3">
                  {{ getTerminalNameForDisplay(terminal) }}
                </div>
                <div class="text-fg-base-fg22 group-hover:text-fg-base-fg10">
                  {{ terminal.ipAddress }}
                </div>
              </div>
              <router-link
                v-if="!terminal.isWebClient && !terminal.isRtuClient"
                :to="{ name: 'terminalsList', query: { terminalId: terminal.id } }"
              >
                <wui-btn
                  icon
                  prepend-icon="edit"
                  :title="$t('common.editDescription')"
                  @click="close()"
                />
              </router-link>
            </div>
          </li>
        </ul>
        <div v-else>
          {{ $t('common.emptyTerminalsList') }}
        </div>
      </div>
    </div>
  </wui-modal>
</template>

<script setup lang="ts">
import { WuiBtn, WuiIcon, WuiModal, closeDialogKey, safeInject } from '@wui/common-library'
import { storeToRefs } from 'pinia'

import { Terminal, useStoreSettingsTerminals, getTerminalNameForDisplay } from '@/entities/user-terminal'

const storeSettingsTerminals = useStoreSettingsTerminals()
const { connectedTerminals: terminals } = storeToRefs(storeSettingsTerminals)

const closeModal = safeInject(closeDialogKey)
const close = () => {
  closeModal(false)
}

const choice = (terminal: Terminal) => {
  closeModal(terminal.id)
}
</script>
